var _rect, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoSymbol = function SvgLogoSymbol(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38.75,
    height: 38.75,
    x: 0.625,
    y: 0.625,
    stroke: "#6E3FF3",
    strokeWidth: 1.25,
    rx: 6.875
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-symbol_svg__a)",
    d: "M28.137 6.875h4.34c.52 0 .812.596.495 1.007l-9.242 11.96a1.25 1.25 0 0 0 .017 1.552l9.179 11.338a.625.625 0 0 1-.486 1.018h-4.32a1.25 1.25 0 0 1-.995-.492l-9.061-11.893a1.25 1.25 0 0 1-.017-1.493L27.126 7.39a1.25 1.25 0 0 1 1.01-.515"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-symbol_svg__b)",
    d: "m18.54 12.58-2.27-5.902a1.25 1.25 0 0 0-1.993-.488l-7.771 6.856a1.25 1.25 0 0 0 .35 2.094l7.74 3.186a1.25 1.25 0 0 0 1.57-.548l2.3-4.142c.18-.324.207-.71.074-1.056"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-symbol_svg__c)",
    d: "M11.758 33.75h3.867c.69 0 1.25-.56 1.25-1.25V20.427c0-.58-.471-1.052-1.052-1.052-.493 0-.931.312-1.093.777L10.578 32.09a1.25 1.25 0 0 0 1.18 1.661"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-symbol_svg__a",
    x1: 33.75,
    x2: 17.5,
    y1: 20.313,
    y2: 20.313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E3FF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB90F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-symbol_svg__b",
    x1: 11.875,
    x2: 11.875,
    y1: 5,
    y2: 18.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E3FF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB90F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-symbol_svg__c",
    x1: 13.438,
    x2: 13.438,
    y1: 33.75,
    y2: 19.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E3FF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB90F8"
  })))));
};
export default SvgLogoSymbol;